module.exports = __webpack_public_path__ + "static/media/non-like-mix.60a4c897.svg";